import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'WarehouseMovements',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewWarehouseMovementsUi()) {
            this.logout();
            return;
        }
        this.loadLookups();
        if (this.isFacilityCenterRole() && this.loginDetails.branchesId) {
            this.filterFacilityId = this.loginDetails.branchesId;
        }
        this.GetInfo();
    },

    computed: {
        statsCards() {
            return [
                this.statCard('إجمالي الحركات', this.pages, 'primary', 'ti ti-arrows-transfer-up-down'),
                this.statCard('الحركات المعروضة', this.Info.length, 'info', 'ti ti-layout-list'),
                this.statCard('حركات واردة', this.countWhere(this.Info, row => Number(row.quantityChange) > 0), 'success', 'ti ti-arrow-down-left'),
                this.statCard('حركات صادرة', this.countWhere(this.Info, row => Number(row.quantityChange) < 0), 'danger', 'ti ti-arrow-up-right'),
            ];
        },
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 25,
            pages: 0,
            Info: [],
            branchesList: [],
            stockingList: [],
            filterFacilityId: null,
            filterStockingId: null,
            filterProductSearch: '',
            filterFrom: null,
            filterTo: null,
            ledgerDialog: false,
            ledgerLines: [],
            ledgerTitle: '',
            ledgerWarehouse: null,
            ledgerProduct: null,
            ledgerFrom: null,
            ledgerTo: null,
        };
    },

    methods: {
        loadLookups() {
            this.$http.GetAllBranches()
                .then((r) => {
                    let list = r.data.info || [];
                    if (this.loginDetails && this.isFacilityCenterRole() && this.loginDetails.branchesId) {
                        const bid = this.loginDetails.branchesId;
                        list = list.filter((b) => b.id === bid);
                    }
                    this.branchesList = list;
                })
                .catch(() => { this.branchesList = []; });

            this.$http.GetAllStocking()
                .then((r) => {
                    let list = r.data.info || [];
                    if (this.loginDetails && this.isFacilityCenterRole() && this.loginDetails.branchesId) {
                        const bid = this.loginDetails.branchesId;
                        list = list.filter((s) => s.branchesId === bid);
                    }
                    this.stockingList = list;
                })
                .catch(() => { this.stockingList = []; });
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetWarehouseMovements(
                this.pageNo,
                this.pageSize,
                this.filterFacilityId || null,
                this.filterStockingId || null,
                (this.filterProductSearch || '').trim(),
                this.filterFrom || null,
                this.filterTo || null
            )
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        productDisplay(row) {
            if (!row) return '—';
            const id = row.productsId || '—';
            const name = row.productName || 'بدون اسم';
            return `#${id} - ${name}`;
        },

        referenceDisplay(row) {
            return row && row.orderCode ? row.orderCode : '—';
        },

        quantityChangeBadgeClass(row) {
            const q = Number(row && row.quantityChange);
            if (Number.isNaN(q)) return 'warehouse-qty-badge--neutral';
            if (q < 0) return 'warehouse-qty-badge--out';
            if (q > 0) return 'warehouse-qty-badge--in';
            return 'warehouse-qty-badge--neutral';
        },

        openLedger(row) {
            if (!row.stockingId || !row.productsId) {
                this.$helper.ShowMessage('info', 'تنبيه', 'لا يوجد مخزن أو صنف في هذا السجل.');
                return;
            }
            this.ledgerFrom = this.filterFrom;
            this.ledgerTo = this.filterTo;
            this.$blockUI.Start();
            this.$http.GetWarehouseProductLedger(row.stockingId, row.productsId, this.ledgerFrom, this.ledgerTo)
                .then((r) => {
                    this.$blockUI.Stop();
                    const d = r.data;
                    this.ledgerWarehouse = d.warehouse;
                    this.ledgerProduct = d.product;
                    this.ledgerLines = d.lines || [];
                    this.ledgerTitle = `حركة الصنف: ${d.product ? d.product.name : ''} — المخزن: ${d.warehouse ? d.warehouse.name : ''}`;
                    this.ledgerDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        reloadLedger() {
            if (!this.ledgerWarehouse || !this.ledgerProduct) return;
            this.$blockUI.Start();
            this.$http.GetWarehouseProductLedger(this.ledgerWarehouse.id, this.ledgerProduct.id, this.ledgerFrom, this.ledgerTo)
                .then((r) => {
                    this.$blockUI.Stop();
                    this.ledgerLines = r.data.lines || [];
                })
                .catch(() => { this.$blockUI.Stop(); });
        },
    },
};
